import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { RegistrationPreSorteoGna } from '../../models/registration-pre-sorteo-gna.model';
import { ReportsService } from '../../services/reports.service';

@Component({
    selector: 'app-report-selection',
    templateUrl: './report-selection.component.html',
    styleUrls: ['./report-selection.component.scss']
})
export class ReportSelectionComponent implements OnInit {
    @Input() registrations: RegistrationPreSorteoGna[];
    @ViewChild('dt') table: Table;

    constructor(private reportsService: ReportsService) { }

    ngOnInit(): void { }

    applyFilterGlobal($event: any, stringVal: string) {
        this.table.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
    }

    printReport(id: number) {
        let filename = "report-" + Date.now() + ".docx";
        this.reportsService.printReport(id).then(
            (response: HttpResponse<Blob>) => {
                let binaryData = [];
                binaryData.push(response.body);
                let downloadLink = document.createElement('a');
                let url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
                downloadLink.href = url;
                downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        );
    }
}